var _rect, _ellipse, _path, _ellipse2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlitterOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 93,
    viewBox: "0 0 162 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.12125,
    height: 9.56733,
    transform: "matrix(-0.626658 -0.685261 0.703838 -0.80452 72.5082 58.8036)",
    fill: "#C154F3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.67028,
    cy: 4.72415,
    rx: 5.67028,
    ry: 4.72415,
    transform: "matrix(-0.182907 -0.984514 0.936659 -0.353584 2.34766 68.9722)",
    fill: "#C154F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1052 74.942L44.9501 64.315L47.2247 76.5364L34.1052 74.942Z",
    fill: "#E63E50"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.15386,
    cy: 3.83974,
    rx: 4.15386,
    ry: 3.83974,
    transform: "matrix(0.981283 -0.0309444 0.132633 0.997045 149.62 19.0834)",
    fill: "#FF9FA9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlitterOne);
export default __webpack_public_path__ + "static/media/glitter_one.b224b78a6193a4f6495039d4d771fa43.svg";
export { ForwardRef as ReactComponent };